import type { AppRouteRecordRaw } from '@/types/router';

const modules: any = import.meta.glob('./modules/*.ts', { eager: true });

const routeModules: AppRouteRecordRaw[] = [];

Object.keys(modules).forEach((key) => {
  const route: AppRouteRecordRaw = modules[key].default;
  routeModules.push(route);
});

export const asyncRoutes = routeModules;
